// src/services/api/warehouse.js
// Warehouse deposit, withdraw, and fetch functions.

import { fetchWithCommonHeaders, API_URL } from './helpers';

// Fetch warehouse data
export const fetchWarehouseData = async (token) => {
    const url = `${API_URL}v2/v3/api/warehouse`;
    const response = await fetchWithCommonHeaders(url, {
        method: 'GET',
        token: token
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch warehouse data: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    return data;
};

// Fetch available items for warehouse deposit
export const fetchDepositItems = async (token) => {
    const url = `${API_URL}v2/v3/api/warehouse/deposit/items`;
    const response = await fetchWithCommonHeaders(url, {
        method: 'GET',
        token: token
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch deposit items: ${response.status} ${errorText}`);
    }

    return response.json();
};

// Deposit items to warehouse
export const depositItemsToWarehouse = async (token, items) => {
    const url = `${API_URL}v2/v3/api/warehouse/deposit`;
    const response = await fetchWithCommonHeaders(url, {
        method: 'POST',
        token: token,
        body: { items }
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to deposit items: ${response.status} ${errorText}`);
    }

    return response.json();
};

// Get available items for withdrawal
export const fetchWithdrawItems = async (token) => {
    const url = `${API_URL}v2/v3/api/warehouse/withdraw/items`;
    const response = await fetchWithCommonHeaders(url, {
        method: 'GET',
        token: token
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch withdraw items: ${response.status} ${errorText}`);
    }

    return response.json();
};

// Withdraw items from warehouse
export const withdrawItemsFromWarehouse = async (token, items) => {
    const url = `${API_URL}v2/v3/api/warehouse/withdraw`;
    const response = await fetchWithCommonHeaders(url, {
        method: 'POST',
        token: token,
        body: { items }
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to withdraw items: ${response.status} ${errorText}`);
    }

    return response.json();
};
